module.exports = __webpack_public_path__ + "media/images/ohap_syllabus_on-7cdb6f4cff17c6d81a8a7713a21d5328.png";